import styled from 'styled-components'

export const ActionsContainer = styled.div`
  margin-top: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const SummaryContainer = styled.div`
  margin: ${props => props.theme.whiteLabel.spacing.sp24} 0;
`
